module.exports = __webpack_public_path__ + "img/img7.3e7f3f0c.svg";